import { AUTH_LOGOUT_REQUEST } from "auth";
import {
    AppActions,
    CLEAR_CMS_TOKEN,
    CREATE_APP_END,
    CREATE_CMS_TOKEN_END,
    DELETE_APP_END,
    DELETE_CMS_TOKEN_END,
    EXPORT_APP_END,
    EXPORT_APP_ERASE,
    FETCH_APP_END,
    FETCH_CMS_TOKENS_END,
    SEARCH_APPS_END,
    SELECT_APP,
    SUBMIT_APP_END,
    UPDATE_APP_END,
    UPDATE_TEMPLATE_END,
    UPLOAD_BANNER_FAILURE,
    UPLOAD_BANNER_SUCCESS,
    UPLOAD_ICON_FAILURE,
    UPLOAD_ICON_SUCCESS,
    UPLOAD_TEMPLATE_END
} from "../actions";
import { AppState } from "../state";
import { clearCMSToken } from "./ClearCMSToken";
import { createApp } from "./CreateApp";
import { createCMSToken } from "./CreateCMSToken";
import { deleteApp } from "./DeleteApp";
import { deleteCMSToken } from "./DeleteCMSToken";
import { exportApp } from "./ExportApp";
import { exportAppErase } from "./ExportAppErase";
import { fetchApp } from "./FetchApp";
import { fetchCMSTokens } from "./FetchCMSTokens";
import { searchApps } from "./SearchApps";
import { selectApp } from "./SelectApp";
import { submitApp } from "./SubmitApp";
import { updateApp } from "./UpdateApp";
import { updateTemplate } from "./UpdateTemplate";
import { uploadBannerFailure, uploadBannerSuccess } from "./UploadBanner";
import { uploadIconFailure, uploadIconSuccess } from "./UploadIcon";
import { uploadTemplate } from "./UploadTemplate";

const initialState: AppState = {
    appPagesMap: {},
    appsMap: {},
    errorMap: {},
    searchAppsResult: {
        apps: [],
        index: 0,
        total: 0
    },
    tokens: {},
    userAnalytics: {}
};


/* tslint:disable cyclomatic-complexity */
export function appReducer(state: AppState = { ...initialState }, action: AppActions): AppState {
    switch (action.type) {
        case AUTH_LOGOUT_REQUEST:
            return { ...initialState };

        case CLEAR_CMS_TOKEN:
            return clearCMSToken(state, action);

        case CREATE_APP_END:
            return createApp(state, action);

        case CREATE_CMS_TOKEN_END:
            return createCMSToken(state, action);

        case EXPORT_APP_END:
            return exportApp(state, action);

        case EXPORT_APP_ERASE:
            return exportAppErase(state);

        case DELETE_APP_END:
            return deleteApp(state, action);

        case DELETE_CMS_TOKEN_END:
            return deleteCMSToken(state, action);

        case FETCH_APP_END:
            return fetchApp(state, action);

        case FETCH_CMS_TOKENS_END:
            return fetchCMSTokens(state, action);

        case SEARCH_APPS_END:
            return searchApps(state, action);

        case UPLOAD_BANNER_SUCCESS:
            return uploadBannerSuccess(state, action);

        case UPLOAD_BANNER_FAILURE:
            return uploadBannerFailure(state, action);

        case UPLOAD_ICON_SUCCESS:
            return uploadIconSuccess(state, action);

        case UPLOAD_ICON_FAILURE:
            return uploadIconFailure(state, action);

        case SELECT_APP:
            return selectApp(state, action);

        case SUBMIT_APP_END:
            return submitApp(state, action);

        case UPDATE_APP_END:
            return updateApp(state, action);

        case UPDATE_TEMPLATE_END:
            return updateTemplate(state, action);

        case UPLOAD_TEMPLATE_END:
            return uploadTemplate(state, action);

        default:
            return state;
    }
}
/* tslint:enable cyclomatic-complexity */
